function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as l, jsx as a } from "react/jsx-runtime";
import { useTheme as i } from "../../hooks.js";
import { useIsInverseVariant as v } from "../../theme-variant-context.js";
import { vars as h } from "../../skins/skin-contract.css-mistica.js";
const n = (_param)=>{
    var { color: o , size: c = 24  } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const t = v(), e = o !== null && o !== void 0 ? o : t ? h.colors.inverse : h.colors.neutralHigh, { skinName: s  } = i();
    return s.match(/^blau/i) ? /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: [
            /* @__PURE__ */ a("path", {
                fill: e,
                d: "M4 2h2.668v2.668H4V2zm12.648 11.436l2.836.944c.724.244 1.16.964 1.044 1.716L19.548 22h-1.38l1.012-6.124a.184.184 0 00-.128-.204l-3.3-1.1a.68.68 0 01-.464-.644V10a.652.652 0 00-1.304 0v7.332c0 .288-.18.54-.448.64a.685.685 0 01-.752-.2l-1.96-2.32a.475.475 0 00-.624.024.533.533 0 00-.112.676L13.34 22h-1.556l-2.88-5.176a1.882 1.882 0 01.408-2.384 1.85 1.85 0 012.436.008c.024.024.048.048.072.076l.8.948V10c0-.604.276-1.144.7-1.512V6h2.668v2.52c.404.368.66.892.66 1.48v3.436zM11.336 2H8.668v2.668h2.668V2zM4 6h2.668v2.668H4V6zm7.336 0H8.668v2.668h2.668V6zM4 10h2.668v2.668H4V10z"
            }),
            /* @__PURE__ */ a("path", {
                fill: e,
                d: "M11.336 10H8.668v2.668h2.668V10zm1.988-8h2.668v2.668h-2.668V2z"
            })
        ]
    })) : /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: [
            /* @__PURE__ */ a("path", {
                fill: e,
                d: "M4.787 2.295c-.73 0-1.207.384-1.207 1.213 0 .398.11.692.305.893.21.216.521.32.902.32s.692-.104.902-.32c.196-.198.306-.495.306-.893 0-.83-.477-1.213-1.208-1.213zm3.553 0c-.732 0-1.208.384-1.208 1.213 0 .398.11.692.305.893.21.216.521.32.902.32s.692-.104.902-.32c.196-.198.305-.495.305-.893 0-.83-.473-1.213-1.207-1.213zm2.34 1.213c0-.83.477-1.213 1.208-1.213s1.207.384 1.207 1.213c0 .398-.109.695-.305.893-.21.216-.52.32-.902.32-.38 0-.692-.104-.902-.32-.196-.201-.305-.495-.305-.893zM4.787 5.572c-.73 0-1.207.387-1.207 1.213 0 .398.11.695.305.894.21.215.521.32.902.32s.692-.105.902-.32c.196-.2.306-.496.306-.894 0-.829-.477-1.213-1.208-1.213zm2.345 1.213c0-.826.476-1.213 1.207-1.213.734 0 1.207.384 1.207 1.213 0 .398-.109.695-.305.894-.21.215-.52.32-.902.32-.38 0-.692-.105-.902-.32-.196-.2-.305-.496-.305-.894zM17.79 21.707h-6.448c-.647 0-.933-.61-1.053-.869-.118-.249-.527-1.075-1.003-2.033l-.107-.216a327.597 327.597 0 01-2.168-4.417c-.33-.7-.198-1.429.34-1.857.557-.446 1.355-.434 1.938.028.302.24.554.571.835 1.044V7.295c.07-1.104.714-1.737 1.761-1.737 1.09 0 1.768.681 1.768 1.773v2.381c.185-.05.375-.075.566-.072.829 0 1.409.411 1.61 1.109a2.09 2.09 0 01.645-.098c.834 0 1.414.417 1.613 1.12a2.07 2.07 0 01.642-.095c1.041 0 1.686.647 1.686 1.692v5.737c0 .798-.227 1.43-.67 1.887-.442.457-1.143.715-1.955.715zm0-1.12c.504 0 .925-.135 1.154-.373.23-.238.353-.61.353-1.107v-5.74c0-.422-.148-.57-.566-.57-.417 0-.566.148-.566.57a.562.562 0 01-.56.561.562.562 0 01-.56-.56v-1.025c0-.423-.148-.572-.566-.572-.417 0-.566.149-.566.572 0 .308-.252.56-.56.56a.562.562 0 01-.56-.56v-1.014c0-.423-.148-.572-.566-.572-.417 0-.566.149-.566.572 0 .308-.252.56-.56.56a.562.562 0 01-.56-.56V7.33c0-.476-.177-.652-.647-.652-.499 0-.614.235-.645.672v.684c0 1.695-.002 5.886 0 6.218.003.476-.254.86-.64.958-.203.05-.712.087-1.124-.675-.362-.67-.622-1.098-.888-1.308-.193-.152-.42-.132-.546-.031-.157.123-.098.339-.023.499.56 1.179 1.504 3.084 2.266 4.613.499 1.003.891 1.793 1.014 2.056.028.076.068.149.115.221h6.367zM4.787 8.85c-.73 0-1.207.386-1.207 1.213 0 .397.11.694.305.893.21.216.521.322.902.322s.692-.103.902-.322c.196-.199.306-.496.306-.893 0-.83-.477-1.213-1.208-1.213z"
            }),
            /* @__PURE__ */ a("path", {
                fill: e,
                d: "M7.132 10.063c0-.827.476-1.213 1.207-1.213.734 0 1.207.383 1.207 1.213 0 .397-.109.694-.305.893-.21.219-.52.322-.902.322-.38 0-.692-.106-.902-.322-.196-.199-.305-.496-.305-.893z"
            })
        ]
    }));
}, d = n;
export { d as default };
